import MmiModal from './MmiModal';

export default MmiModal;
